/** @format */

import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	ViewChild
} from '@angular/core';
import { HmfButtonComponent, HmfModalComponent } from '@dsg-tech/homefield-angular';
import { Subject, takeUntil } from 'rxjs';
import { ProductListCompareService } from '@plp/data-access/services';

@Component({
	selector: 'plp-components-compare-painted-door-modal',
	imports: [HmfButtonComponent, HmfModalComponent],
	templateUrl: './compare-painted-door-modal.component.html',
	styleUrl: './compare-painted-door-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComparePaintedDoorModalComponent implements OnDestroy {
	private readonly UNSUBSCRIBE$ = new Subject<void>();

	@ViewChild('paintedDoorModal') paintedDoorModal: HmfModalComponent;

	paintedDoorTest$ = this.compareService.paintedDoorTest$.pipe(takeUntil(this.UNSUBSCRIBE$));

	constructor(
		private readonly compareService: ProductListCompareService,
		private readonly cdr: ChangeDetectorRef
	) {
		this.paintedDoorTest$.subscribe(() => {
			this.openPaintedDoorModal();
		});
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	openPaintedDoorModal(): void {
		this.paintedDoorModal.openModal();
		this.cdr.detectChanges();
	}

	backToShopping(): void {
		this.paintedDoorModal.closeModal();
		this.paintedDoorModal.open = false;
		this.cdr.detectChanges();
	}

	onClosePressed(): void {
		this.paintedDoorModal.open = false;
		this.cdr.detectChanges();
	}
}
